import React from "react";
import { Helmet } from "react-helmet-async";
import '../sass/privacy-policy.scss';

const PrivacyPolicy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | DentalStores.in</title>
      <meta name="description" content="Read the privacy policy for DentalStores.in mobile app and website. Learn how we protect your data and privacy." />
      <link rel="canonical" href="https://www.dentalstores.in/privacy-policy" />
    </Helmet>
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>
        This Privacy Policy describes how DentalStores.in ("we", "us", or "our") collects, uses, and protects your personal information when you use our website and mobile applications (available on Play Store and App Store).
      </p>
      <h2>Information We Collect</h2>
      <ul>
        <li>Personal details (name, email, phone number, address) provided during registration or checkout.</li>
        <li>Order and payment information.</li>
        <li>Device and usage data (app version, device type, IP address).</li>
        <li>Location data (if you allow location access).</li>
      </ul>
      <h2>How We Use Your Information</h2>
      <ul>
        <li>To process orders and deliver products.</li>
        <li>To provide customer support and respond to inquiries.</li>
        <li>To improve our services and user experience.</li>
        <li>To send updates, offers, and marketing communications (you can opt out).</li>
      </ul>
      <h2>Data Protection</h2>
      <p>
        We implement industry-standard security measures to protect your data. Your information is stored securely and is not shared with third parties except as required for order fulfillment or by law.
      </p>
      <h2>Third-Party Services</h2>
      <p>
        We may use third-party services (such as payment gateways, analytics, and delivery partners) that have their own privacy policies. We recommend reviewing their policies for more information.
      </p>
      <h2>Your Rights</h2>
      <ul>
        <li>You can access, update, or delete your personal information by contacting us.</li>
        <li>You can opt out of marketing communications at any time.</li>
      </ul>
      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated date.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:support@dentalstores.in">support@dentalstores.in</a>.
      </p>
      <p>Last updated: 7 October 2025</p>
    </div>
  </>
);

export default PrivacyPolicy;
